import React from 'react';
import { useContext, useEffect, useState } from 'react';

import { UserContext } from './provider/UserProvider';
import { Button, Card, Container, ContainerFlex, TextLocalized } from './styled/Styled';
import { HttpConnection, HttpMethod, HttpOperations, imageURL } from './util/HttpConnection';


const PillItem = ({ item, showItem }) => {

    const [color, setColor] = useState();
    const { state } = useContext(UserContext);

    useEffect(() => {
        if (item.done) setColor(item.done.length > 0 ? "color-green" : "color-black-a40")
        else setColor("color-black-a40")
    }, [item])

    const toggleDone = () => {
        setColor(color === "color-green" ? "color-black-a40" : "color-green");
        HttpConnection(`${HttpOperations.pills}/${item.id}/done`,
            responde => { }, error => console.log(error), HttpMethod.post);
    }

    return (
        <Container width="12" lg="4" px="8">
            <Card flex shadowOn color="color-white" minheight="100%" border="solid" borderWidth="0px" borderColor="color-black" justify="center" direction="column">

                <Card flex width="12" align="flex-start" justify="flex-end" minheight="100px" fontColor="color-blue-dark" px="8" image={imageURL(item.image)} radiusbl="0" radiusbr="0">
                    {
                        state.login && item.done ?
                            <Button onClick={toggleDone} flex shadowOn align="center" color="color-white" radius="20px" px="8">
                                <Card cursor="pointer" minwidth="18px" height="18px" radius="50%" border="solid" borderColor="color-black" borderWidth="1px" color={color} />
                                <Container cursor="pointer" ph="8" fontWeight="bold" children={<TextLocalized children="actionDone" />} />
                            </Button>
                            : null
                    }
                </Card>

                <ContainerFlex width="12" expand direction="column" justify="space-between">
                    <Container width="12" pv="8">
                        <Container width="12" textAlign="center" px="8" fontWeight="bold" fontSize="18px" children={`${item.content.title ?? ""}`} />
                        <Container width="12" textAlign="center" ph="8" fontSize="14px" children={item.content.description} />
                    </Container>

                    <Container width="12" px="8">
                        <Button width="wrap" onClick={showItem} ph="16" pv="8" color="color-primary" hoverColor="color-blue-dark" textAlign="center" fontColor="color-white" textTransform="uppercase" children={<TextLocalized children="actionGetStart" />} />
                    </Container>
                </ContainerFlex>

            </Card>
        </Container>
    );
};

export default PillItem;